import React from 'react'
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Theme } from '@theme'

export type ColumnDividerProps = { style?: StyleProp<ViewStyle> }

// Thin vertical line separating the list column from the detail column on the
// two-column (web / tablet) layouts. Stretches to the full height of its row,
// so the parent must be a flexDirection: 'row' container.
export const ColumnDivider = ({ style }: ColumnDividerProps): React.ReactElement => {
  const theme = useTheme()
  const styles = getStyle(theme)
  return <View testID="column-divider" style={[styles.divider, style]} />
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    divider: {
      width: 1,
      alignSelf: 'stretch',
      backgroundColor: theme.colors.grey,
    },
  })
